import { create } from "zustand";

export const useBookStore = create((set)=>({
    book:{},
    setBook:(book)=> set(() => ({book:book})),
}))